import * as React from 'react';

export interface ITypeSeedDivider {
  data: any;
  isEditorView: boolean;
}

export default class TypeSeedDivider extends React.Component<ITypeSeedDivider> {
  constructor(props: ITypeSeedDivider) {

    super(props);
  }

  render() {
    if(!this.props.data) {
      return <div></div>
    }
    const { image_path } = this.props.data;
    const className = `seed-divider`;
    return (
      <div className={className}>
        <img src={image_path} alt="" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/PageTypes/TypeSeedDivider.tsx